import React from "react";

const IMG = "https://images.unsplash.com/photo-1602094689189-a7cb72dc1ff9?auto=format&fit=crop&w=1600&q=80";

export default function Story() {
  return (
    <div className="pt-32 pb-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="label-mono mb-4 text-[var(--primary)]">॥ Our Story ॥</div>
        <h1 className="font-sacred text-5xl md:text-7xl leading-[0.95] tracking-tight max-w-4xl embossed-light">
          A QUIETER KIND OF <span className="embossed">COFFEE</span>.
        </h1>
      </div>

      <div className="mt-16 relative h-[60vh] min-h-[400px]">
        <img src={IMG} alt="Roastery atmosphere" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg)] to-transparent" />
      </div>

      <div className="max-w-[880px] mx-auto px-6 md:px-12 mt-20 space-y-10 text-[var(--text-secondary)] text-lg leading-relaxed">
        <p>
          Rudra Roast Coffee started as a Sunday habit. A small drum, six kilos of green beans, and a rotating cast of friends who kept coming back for more. We roasted in the dark, past midnight, when the estate was quiet and the temperature was kind.
        </p>
        <p>
          Six years later, the drum is bigger — but the philosophy hasn&apos;t budged. We roast to order, in batches of no more than eight kilos. We source directly from the estates we visit twice a year. And we still work best after midnight.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-10 border-t border-[var(--border)]">
          {[
            ["01", "Source", "Six estates across South India. Cupped, scored, and traced."],
            ["02", "Blend", "Composed by our head roaster the day it ships."],
            ["03", "Ship", "Vacuum-sealed with a one-way valve. Fresh for 45 days."],
          ].map(([n, t, d]) => (
            <div key={n}>
              <div className="font-mono text-3xl text-[var(--primary)]">{n}</div>
              <div className="font-serif text-2xl mt-2">{t}</div>
              <div className="mt-3 text-[var(--text-secondary)] text-base">{d}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
